module.exports = __webpack_public_path__ + "img/product_stkr_sale.2341b3de.svg";